module.exports = __webpack_public_path__ + "components/flag/static/square/cg-d7daa3dbdcccb5e84902503119e34c1b.svg";